import type { PayoutStatementView } from '@/api/tmm/types';

/** Sum `payableMinor` within each currency. Never add across currencies. */
export function payableByCurrency(
  rows: PayoutStatementView[],
): { currency: string; payableMinor: number }[] {
  const byCurrency = new Map<string, number>();
  for (const row of rows) {
    const current = byCurrency.get(row.currency) ?? 0;
    byCurrency.set(row.currency, current + row.payableMinor);
  }
  return [...byCurrency.entries()].map(([currency, payableMinor]) => ({ currency, payableMinor }));
}

export function holdCount(rows: PayoutStatementView[]): number {
  let count = 0;
  for (const row of rows) {
    if (row.hold !== undefined) count += 1;
  }
  return count;
}
